import { render, staticRenderFns } from "./AlbumArticleItem.vue?vue&type=template&id=3dfc87e4&"
import script from "./AlbumArticleItem.vue?vue&type=script&lang=js&"
export * from "./AlbumArticleItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-web/cafe-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dfc87e4')) {
      api.createRecord('3dfc87e4', component.options)
    } else {
      api.reload('3dfc87e4', component.options)
    }
    module.hot.accept("./AlbumArticleItem.vue?vue&type=template&id=3dfc87e4&", function () {
      api.rerender('3dfc87e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/bbs-list/bottom/components/AlbumArticleItem.vue"
export default component.exports